import type { File } from "@/interfaces/estimation.interface";
import { Check, Loader2, Trash2 } from "lucide-react";
import { useCallback } from "react";

interface UploadedFileProps {
  file: File;
  onRemove: (uploadId: string) => void;
  validation?: {
    status: "VALIDATING" | "CLASSIFIED" | "ERROR";
    format?: string;
  };
}

export const UploadedFile = ({ file, onRemove, validation }: UploadedFileProps) => {
  const remove = useCallback(() => {
    onRemove(file.uploadId || "");
  }, [file.uploadId, onRemove]);

  return (
    <div className="flex w-[200px] flex-row justify-between rounded-lg bg-white p-2 text-xs font-semibold shadow-lg">
      <div className="flex flex-col space-y-1 truncate">
        <p className="truncate">{file.originalname}</p>
        <p className="font-normal">
          {file.size < 1024 * 1024 ? `${(file.size / 1024)?.toFixed(2)} KB` : `${(file.size / (1024 * 1024))?.toFixed(2)} MB`} - {"100%"}
        </p>
        {validation?.status === "VALIDATING" && (
          <div className="inline-flex w-fit items-center gap-1 rounded-full bg-blue-100 px-2 py-0.5 text-[10px] text-blue-700">
            <Loader2 className="h-3 w-3 animate-spin" />
            Validating
          </div>
        )}
        {validation?.status === "CLASSIFIED" && validation.format && (
          <div
            className={`inline-flex w-fit items-center gap-1 rounded-full px-2 py-0.5 text-[10px] ${
              validation.format === "UNKNOWN" ? "bg-red-100 text-red-700" : "bg-emerald-100 text-emerald-800"
            }`}
          >
            {validation.format === "UNKNOWN" ? null : <Check className="h-3 w-3" />}
            {validation.format === "UNKNOWN" ? "Unsupported Format" : "Validated"}
          </div>
        )}
        {validation?.status === "ERROR" && (
          <div className="inline-flex w-fit items-center rounded-full bg-red-100 px-2 py-0.5 text-[10px] text-red-700">
            Validation Error
          </div>
        )}
      </div>
      <div>
        <Trash2 className="h-4 w-4 cursor-pointer text-[#71717a]" onClick={remove} />
      </div>
    </div>
  );
};
